require('./overrides.scss')

export default {
  theme: {
    themes: {
      light: {
        primary: '#4357ed',
        accent: '#404040',
        secondary: '#464a65',
        success: '#20BF1A',
        info: '#007bff',
        warning: '#FFC048',
        error: '#BD1D21',
        colorWhite: '#F2F4F4',
        colorBlack: '#3B3B3B',
        colorGrey: '#888888',
        colorLightGrey: '#A7A7A7',
        orange: '#ff9402'
      },
      dark: {
        primary: '#4357ed',
        accent: '#404040',
        secondary: '#464a65',
        success: '#20BF1A',
        info: '#007bff',
        warning: '#FFC048',
        error: '#BD1D21',
        colorWhite: '#F2F4F4',
        colorBlack: '#3B3B3B',
        colorGrey: '#888888',
        colorLightGrey: '#A7A7A7',
        orange: '#ff9402'
      },
    },
  },
}
